var React = require('react');
var createReactClass = require('create-react-class');
var Link = require('react-router').Link;
var LinkWrapper = require('../../components/linkWrapper.jsx')(Link);

var PracticeHeader = createReactClass({
  render: function () {
    var logoUrl =
      'https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/logo.png';

    return (
      <header id="header">
        <div className="title-bar clearfix">
          <LinkWrapper
            className="float-left"
            to="/sign-up"
            id="logo"
            title="Back to home"
            action="Home Logo - Mobile"
            handler={this.props.clickTracking}
          >
            <img src={logoUrl} alt="MyGiHealth" />
          </LinkWrapper>
        </div>
        <div className="top-bar">
          <LinkWrapper
            className="show-for-large"
            to="/sign-up"
            id="logo"
            title="Back to home"
            action="Home Logo"
            handler={this.props.clickTracking}
          >
            <img src={logoUrl} alt="MyGiHealth" className="show-for-large" />
          </LinkWrapper>
        </div>
        <div className="title-bar clearfix">
          <LinkWrapper
            className="float-right"
            to="/sign-up"
            id="practice-logo"
            title="Back to home"
            action="Practice Logo - Mobile"
            handler={this.props.clickTracking}
          >
            <img
              src={this.props.practice.logoUrl || ''}
              alt={this.props.practice.name || ''}
            />
          </LinkWrapper>
        </div>
        <div className="top-bar">
          <LinkWrapper
            className="practice"
            to="/sign-up"
            id="practice-logo"
            title="Back to home"
            action="Practice Logo"
            handler={this.props.clickTracking}
          >
            <img
              src={this.props.practice.logoUrl || ''}
              alt={this.props.practice.name || ''}
              className="show-for-large"
            />
          </LinkWrapper>
        </div>
      </header>
    );
  },
});

module.exports = PracticeHeader;



// WEBPACK FOOTER //
// ./src/common/routes/practice/components/practiceHeader.jsx